var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 16.667C13.0843 16.667 16.666 13.0853 16.666 8.66699C16.666 4.24871 13.0843 0.666992 8.66602 0.666992C4.24774 0.666992 0.666016 4.24871 0.666016 8.66699C0.666016 13.0853 4.24774 16.667 8.66602 16.667ZM12.3731 7.95989L9.37312 4.95989C8.9826 4.56936 8.34943 4.56936 7.95891 4.95989L4.95891 7.95989C4.56838 8.35041 4.56838 8.98357 4.95891 9.3741C5.34943 9.76462 5.9826 9.76462 6.37312 9.3741L7.66602 8.08121L7.66602 11.667C7.66602 12.2193 8.11373 12.667 8.66602 12.667C9.2183 12.667 9.66602 12.2193 9.66602 11.667V8.08121L10.9589 9.3741C11.3494 9.76462 11.9826 9.76462 12.3731 9.3741C12.7636 8.98357 12.7636 8.35041 12.3731 7.95989Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUp);
export default __webpack_public_path__ + "static/media/icon-up.ceabd1bd08919e28a2359737c1dbf117.svg";
export { ForwardRef as ReactComponent };